<script lang="ts">
    import '../../legacy-app.css';
    import { useFrontendSentry } from '$lib/services/sentry/sentry.frontend';
    import { preloadCode, preloadData } from '$app/navigation';
    import { onMount, setContext } from 'svelte';
    import FabricShell from '$lib/layouts/fabric/Shell/Shell.svelte';
    import { Cookies, fromDocument } from '$lib/services/helpers/cookies';
    import { storeDeviceInfo } from '../(noshell)/[[market=isMarket]]/register/deviceTracker/deviceTracker';
    import { getRoute, isActiveRoute } from '$src/lib/services/navigation';
    import { emitNavigateToNativeLogin } from '$lib/services/native';
    import { isPracticeOrPlay } from '$src/lib/services/page/utils';
    import PageBuilder from '$src/lib/components/PageBuilder/PageBuilder.svelte';
    import { fromStore } from 'svelte/store';

    let { data, children } = $props();

    let { market, shellTranslations, isLoggedIn, rgBarBlock, debugMode } = $derived(data);

    let vertical = $state({ current: 'sports' });
    let isInGamePage = fromStore<boolean>(isPracticeOrPlay());

    setContext('vertical', vertical);
    setContext('isInGamePage', isInGamePage);

    const isLoginRoute = isActiveRoute('/log-in');

    $effect(() => {
        if (isLoginRoute) {
            emitNavigateToNativeLogin();
        }
    });

    $effect(() => useFrontendSentry());

    onMount(() => {
        const preloadRegisterUrl = getRoute('/register')!;
        setTimeout(() => {
            preloadCode(preloadRegisterUrl);
            preloadData(preloadRegisterUrl);
        }, 2000);
        const cookies = new Cookies(fromDocument(document));
        storeDeviceInfo(cookies);
    });
</script>

{#if isInGamePage.current && isLoggedIn}
    {@render children()}
{:else if shellTranslations}
    <FabricShell {market} translations={shellTranslations} {isLoggedIn}>
        {#snippet rgBarSlot()}
            <PageBuilder debug={debugMode} {...rgBarBlock} />
        {/snippet}
        {@render children()}
    </FabricShell>
{/if}
